/**
 * @Author:      ge.yuankai
 * @DateTime:    2018-03-14
 * @Description: 新建/编辑  图文稿页
 */
'use strict';
angular.module("imageTextModule",['imageTextRouterModule','imageTextDetailModule']).
controller('imageTextCtrl', ['$scope', '$element', '$state','$stateParams', '$q', '$compile', 'httpService', 'modalDialog', 'ueditorService', '$validation', 'localStorageService', '$timeout','editPictureService', function($scope, $element,$state, $stateParams, $q, $compile, httpService, modalDialog, ueditorService, $validation, localStorageService, $timeout,editPictureService) {
    initStatus();
    initData();
    /**
     * [initStatus description] 初始化参数
     */
    function initStatus(){
        $scope.status = {
            inputData:'',
        }
    };

    function initData(){
    	getPubWayInfo().then(function() {
            return initList();
        }).then(function() {
            loadUeditor();
        });
    };
    /*
     * 文章数据
     */
    $scope.list = {
        id: 0,
        articleTitle: "",
        articleChannel: 0,
        articleHtmlCon: '',
        articleStatus: ""
    };
    /**
     * [initList description] 初始化表单数据
     * @return {[type]} [description]
     */
    function initList() {
        var deffer = $q.defer();
        if (!!$stateParams.id) {
            $scope.status.hide = false;
            getDraftInfo().then(function(result) {
                for (var i in $scope.list) {
                    $scope.list[i] = result.articeInfo[i];
                }
                $scope.selectedChannel = result.chnlsAndTags;
                deffer.resolve();
            });
        } else {
            deffer.resolve();
        }
        return deffer.promise;
    }
    /**
     * [loadUeditor description] 加载编辑器
     * @return {[type]} [description]
     */
    function loadUeditor() {
        var $ueditor = $("<ueditor></ueditor>");
        var $ueditorLocation = $element.find("ueditorLocation");
        LazyLoad.js(["./static/ueditor/ueditor.config.js?v=11.4", "./static/ueditor/ueditor.all.js?v=11.4"], function() {
            $ueditor.attr({
                list: "list",
                "has-content": "status.hasContent",
                versionid: $scope.list.id,
                infullscreen: "status.infullscreen",
                placeholder: "请输入文章正文"
            });
            $ueditor = $compile($ueditor)($scope);
            $ueditorLocation.append($ueditor);
        });
    }
    /**
     * [getDraftInfo description] 查询稿件信息
     * @return {[type]} [description]
     */
    function getDraftInfo() {
        var deffer = $q.defer();
        var params = {
            articleId: $stateParams.id
        };
        httpService.http("/mcnww/web/pgcArticle/findById.do", params, "get").then(function(result) {
            deffer.resolve(result);
        });
        return deffer.promise;
    }
    /**
     * [getPubWay description] 获取发布渠道相关信息
     * @return {[type]} [description]
     */
    function getPubWayInfo() {
        var deffer = $q.defer();
        httpService.http("/mcnww/web/channel/querySignChnlList.do", "", "post").then(function(data) {
            $scope.channels = data.data;
            deffer.resolve();
        });
        return deffer.promise;
    }
    /**
     * [save description] 保存或发布文章
     * @return {[type]} [description]
     */
    $scope.save = function(ispub) {
        saveContent().then(function() {
            return validator();
        }).then(function() {
            return saveArticle(ispub);
        }).then(function(data) {
            if (data.success) {
                var newId = data.id;
                $scope.list.id = newId;
                reFreshListPage();
                ueditorService.saveToLocal(newId);
                modalDialog.success((ispub ? "投稿" : "保存稿件") + "成功", "success", false, function() {
                    if (ispub) {
                        window.close();
                    }
                    $state.go("imagetext", { id: newId, type: 5 }, { reload: "imagetext" });
                }, function() {}, '', 'left0');
            }
        });
    };
    /**
     * [saveArticle description] 保存文章
     * @return {[type]} [description]
     */
    function saveArticle(ispub) {
    	var defer = $q.defer();
    	var channelData = getSelectChannel();
    	if(channelData.length == 0){
    		modalDialog.alertType("请至少选择一个发布渠道", "", "warning", "confirm");
    		var html = $("html");
			var div = $(".dingweidiv")[0];
	      	html.animate({ scrollTop: html.scrollTop() + $(div).offset().top - html.offset().top }, 1000);
    		defer.reject({success:false});
    	}else{
	        var d = $scope.list;
	        var boo = ispub==0 ? false:true;
	        var params = {
	            articleTitle: d.articleTitle,
	            articleContent: d.articleHtmlCon,
	            articleHtmlCon:d.articleHtmlCon,
	            channels: JSON.stringify(channelData),
	            articleType:'0',
	            articleWordsCount:d.DOCWORDSCOUNT,
	            bPub: boo
	        };
	        //新建的时候不传id
	        if(d.id != 0){
				params.id = d.id        	
	        }
	        httpService.http("/mcnww/web/pgcArticle/saveOtherArticle.do", params, "post").then(function(result) {
		    	defer.resolve(result);
	        });
    	}
        return defer.promise;
    }

    /**
     * [saveContent description] 保存正文
     * @return {[type]} [description]
     */
    function saveContent() {
        var deffer = $q.defer();
        ueditorService.saveContent($scope.list);
        if ($scope.list.articleHtmlCon === "") {
            $timeout(function() {
                //表单校验手动触发
                $scope.imageTextForm.content.$error.content = true;
                $scope.imageTextForm.content.$valid = false;
                $scope.imageTextForm.content.$invalid = true;
                $scope.imageTextForm.$error.content = [$scope.imageTextForm.content];
                $scope.imageTextForm.$valid = false;
                $scope.imageTextForm.$invalid = true;
                deffer.resolve();
            });
        } else {
            deffer.resolve();
        }
        return deffer.promise;
    }
    /**
     * [validator description] 表单校验
     * @return {[type]} [description]
     */
    function validator() {
        var deffer = $q.defer();
        $validation.validate($scope.imageTextForm).success(function() {
            deffer.resolve();
        }).error(function(result) {
            angular.invalidPosition($scope.imageTextForm, $element);
        });
        return deffer.promise;
    }
    /**
     * [getSelectChannel description] 获取选取的渠道以及上传的图片
     * @return {[type]} [description]
     */
    function getSelectChannel(){
    	var  data = [];
    	var channels = $scope.channels;
    	for(var i = 0 ;i<channels.length;i++){
    		var _c = channels[i];
    		if(_c.checked){
    			var o = {    
    				channelId:_c.id,//渠道ID
    				channelName: _c.channelName,//渠道名称 
    				coverType: _c.coverType,//封面类型-单图 
    			}
    			var imgArr = [];
    			if(_c.coverType==0){
    				imgArr[0]=_c.pic1;
    			}else if(_c.coverType==1){
    				imgArr[0]=_c.pic1;
    				imgArr[1]=_c.pic2;
    				imgArr[2]=_c.pic3;
    			}
    			o.coverImg = imgArr;//封面图片数组
    			data.push(o);
    		}
    	}
    	return data;
    }
    /**
     * [reFreshList description] 刷新列表页
     * @return {[type]} [description]
     */
    function reFreshListPage() {
        localStorageService.set("refresh", Math.random());
    }
}]);